import {useEffect, useState} from 'react'
import ClearableInput from '../ClearableInput'

export default function TutorProfileRateList({tutorProfile}) {
  const sortedSubjectLevels = tutorProfile.subjectLevels.sort((a, b) => (
    a.level.position - b.level.position || a.subject.position - b.subject.position
  ))

  const [searchTerm, setSearchTerm] = useState('')
  const [filteredSubjectLevels, setFilteredSubjectLevels] = useState(sortedSubjectLevels)

  useEffect(() => {
    let filtered = sortedSubjectLevels.filter(subjectLevel => (
      subjectLevel.subject.name.toLowerCase().match(searchTerm.toLowerCase()) ||
        subjectLevel.level.name.toLowerCase().match(searchTerm.toLowerCase())
    ))
    setFilteredSubjectLevels(filtered)
  }, [searchTerm])

  const clearSearch = () => {
    setSearchTerm('')
    setFilteredSubjectLevels(sortedSubjectLevels)
  }

  return (
    <div className="table-responsive">
      <table className="table">
        <thead>
          <tr>
            <th>
              <div className="d-flex">
                <ClearableInput showClear={!!searchTerm} onClear={clearSearch}>
                  <input
                    value={searchTerm}
                    placeholder="Filter by subject or level"
                    className="form-control form-control-sm"
                    onChange={event => setSearchTerm(event.target.value)} />
                </ClearableInput>
              </div>
            </th>
            {tutorProfile.lessonsInPerson &&
              <th>In-Person</th>
            }
            {tutorProfile.lessonsOnline &&
              <th>Online</th>
            }
          </tr>
        </thead>
        <tbody>
          {filteredSubjectLevels.map(subjectLevel => (
            <tr key={subjectLevel.id}>
              <td>{subjectLevel.displayName}</td>
              {tutorProfile.lessonsInPerson &&
                <td>{subjectLevel.formattedInPersonRate}</td>
              }
              {tutorProfile.lessonsOnline &&
                <td>{subjectLevel.formattedOnlineRate}</td>
              }
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
